import { graphql } from 'react-apollo'
import query from './query.graphql'

const mapDataToProps = ({ data: { userSettings } }) => ({
  ...userSettings,
  isListView: userSettings.browseStoresView !== 'grid',
})

const withUserSettings = graphql(query, {
  props: mapDataToProps,
})

export default withUserSettings
